"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NaturalSiteIcon = NaturalSiteIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function NaturalSiteIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.8716 3.54947C14.4893 2.86982 13.5107 2.86982 13.1284 3.54947L10.5258 8.17641C10.3545 8.48082 10.3545 8.85251 10.5258 9.15693L12.7282 13.0723C12.948 13.4631 12.8808 13.9525 12.5637 14.2696L12.4317 14.4017C11.9636 14.8697 11.1785 14.7626 10.8538 14.1858C9.84762 12.3983 8.65913 10.2847 7.87074 8.88238C7.48851 8.20249 6.51042 8.20369 6.12804 8.88349L1.83827 16.5097C1.46331 17.1763 1.94502 18 2.70985 18H21.2902C22.055 18 22.5367 17.1763 22.1617 16.5097L14.8716 3.54947Z",
    fill: "currentColor"
  }));
}